import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-matter" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "right-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackIcon = _resolveComponent("BackIcon")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_NcActions = _resolveComponent("NcActions")!
  const _component_SortDateDIcon = _resolveComponent("SortDateDIcon")!
  const _component_SortDateAIcon = _resolveComponent("SortDateAIcon")!
  const _component_SlotAlphabeticalDIcon = _resolveComponent("SlotAlphabeticalDIcon")!
  const _component_SlotAlphabeticalAIcon = _resolveComponent("SlotAlphabeticalAIcon")!
  const _component_SortIcon = _resolveComponent("SortIcon")!
  const _component_NcActionRadio = _resolveComponent("NcActionRadio")!
  const _component_NcActionSeparator = _resolveComponent("NcActionSeparator")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_ShareIcon = _resolveComponent("ShareIcon")!
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!
  const _component_EditIcon = _resolveComponent("EditIcon")!
  const _component_DeleteIcon = _resolveComponent("DeleteIcon")!
  const _component_AlbumCreateModal = _resolveComponent("AlbumCreateModal")!
  const _component_AlbumDeleteModal = _resolveComponent("AlbumDeleteModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isAlbumList)
      ? (_openBlock(), _createBlock(_component_NcActions, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_NcActionButton, {
              "aria-label": _ctx.t('memories', 'Back'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back()))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_BackIcon, { size: 20 })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Back')) + " ", 1)
              ]),
              _: 1
            }, 8, ["aria-label"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.name), 1),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isAlbumList)
        ? (_openBlock(), _createBlock(_component_NcActions, {
            key: 0,
            title: _ctx.t('memories', 'Sorting order'),
            forceMenu: true
          }, {
            icon: _withCtx(() => [
              (_ctx.isDateSort)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.isDescending)
                      ? (_openBlock(), _createBlock(_component_SortDateDIcon, {
                          key: 0,
                          size: 20
                        }))
                      : (_openBlock(), _createBlock(_component_SortDateAIcon, {
                          key: 1,
                          size: 20
                        }))
                  ], 64))
                : (_ctx.config.album_list_sort & _ctx.c.ALBUM_SORT_FLAGS.NAME)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.isDescending)
                        ? (_openBlock(), _createBlock(_component_SlotAlphabeticalDIcon, {
                            key: 0,
                            size: 20
                          }))
                        : (_openBlock(), _createBlock(_component_SlotAlphabeticalAIcon, {
                            key: 1,
                            size: 20
                          }))
                    ], 64))
                  : (_openBlock(), _createBlock(_component_SortIcon, {
                      key: 2,
                      size: 20
                    }))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_NcActionRadio, {
                name: "sort",
                "aria-label": _ctx.t('memories', 'Last updated'),
                "model-value": _ctx.sortField,
                value: "last_update",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeSort(_ctx.c.ALBUM_SORT_FLAGS.LAST_UPDATE))),
                "close-after-click": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Last updated')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "model-value"]),
              _createVNode(_component_NcActionRadio, {
                name: "sort",
                "aria-label": _ctx.t('memories', 'Creation date'),
                "model-value": _ctx.sortField,
                value: "created",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeSort(_ctx.c.ALBUM_SORT_FLAGS.CREATED))),
                "close-after-click": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Creation date')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "model-value"]),
              _createVNode(_component_NcActionRadio, {
                name: "sort",
                "aria-label": _ctx.t('memories', 'Album name'),
                "model-value": _ctx.sortField,
                value: "name",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeSort(_ctx.c.ALBUM_SORT_FLAGS.NAME))),
                "close-after-click": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Album name')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "model-value"]),
              _createVNode(_component_NcActionSeparator),
              _createVNode(_component_NcActionRadio, {
                name: "sort-dir",
                "aria-label": _ctx.isDateSort ? _ctx.t('memories', 'Oldest first') : _ctx.t('memories', 'Ascending'),
                "model-value": _ctx.sortDir,
                value: "asc",
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setDescending(false))),
                "close-after-click": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isDateSort ? _ctx.t('memories', 'Oldest first') : _ctx.t('memories', 'Ascending')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "model-value"]),
              _createVNode(_component_NcActionRadio, {
                name: "sort-dir",
                "aria-label": _ctx.isDateSort ? _ctx.t('memories', 'Newest first') : _ctx.t('memories', 'Descending'),
                "model-value": _ctx.sortDir,
                value: "desc",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setDescending(true))),
                "close-after-click": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isDateSort ? _ctx.t('memories', 'Newest first') : _ctx.t('memories', 'Descending')), 1)
                ]),
                _: 1
              }, 8, ["aria-label", "model-value"])
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_component_NcActions, {
        inline: _ctx.isMobile ? 1 : 3
      }, {
        default: _withCtx(() => [
          (_ctx.isAlbumList)
            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                key: 0,
                "aria-label": _ctx.t('memories', 'Create new album'),
                title: _ctx.t('memories', 'Create new album'),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.refs().createModal.open(false))),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_PlusIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Create new album')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true),
          (_ctx.canEditAlbum)
            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                key: 1,
                "aria-label": _ctx.t('memories', 'Share album'),
                title: _ctx.t('memories', 'Share album'),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openShareModal())),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_ShareIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Share album')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true),
          (!_ctx.isAlbumList)
            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                key: 2,
                "aria-label": _ctx.t('memories', 'Download album'),
                title: _ctx.t('memories', 'Download album'),
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadAlbum())),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_DownloadIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Download album')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true),
          (_ctx.canEditAlbum)
            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                key: 3,
                "aria-label": _ctx.t('memories', 'Edit album details'),
                title: _ctx.t('memories', 'Edit album details'),
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.refs().createModal.open(true))),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_EditIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Edit album details')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true),
          (!_ctx.isAlbumList)
            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                key: 4,
                "aria-label": _ctx.t('memories', 'Remove album'),
                title: _ctx.t('memories', 'Remove album'),
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.refs().deleteModal.open())),
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_DeleteIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Remove album')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["inline"])
    ]),
    _createVNode(_component_AlbumCreateModal, { ref: "createModal" }, null, 512),
    _createVNode(_component_AlbumDeleteModal, { ref: "deleteModal" }, null, 512)
  ]))
}